import { jsx } from 'react/jsx-runtime';
import GoogleMapReact from 'google-map-react';
import { BoxMarker } from './BoxMarker/BoxMarker.js';
import { IconMarker } from './IconMarker/IconMarker.js';

function GoogleMap({
  children,
  ...props
}) {
  return jsx(GoogleMapReact, {
    ...props,
    children: children
  });
}
GoogleMap.BoxMarker = BoxMarker;
GoogleMap.IconMarker = IconMarker;

export { GoogleMap };
